import React from "react";
import { IUser } from "../../../../api/homesites/homesites.types";
import { HomeSitesDataIndex } from "../../../../reactQuery/homeSitesDataIndex/types";
import { ConfirmDialog } from "./ConfirmDialog";

interface AssignConfirmDialogProps {
     open: boolean;
     selectedBulkConcierge: IUser | null;
     selectedBulkCommunity: string;
     homesites: HomeSitesDataIndex[];
     isBulkAssigning: boolean;
     onConfirm: () => void;
     onCancel: () => void;
}

export const AssignConfirmDialog: React.FC<AssignConfirmDialogProps> = ({
     open,
     selectedBulkConcierge,
     selectedBulkCommunity,
     homesites,
     isBulkAssigning,
     onConfirm,
     onCancel,
}) => {
     const homesitesToUpdate = homesites?.filter((hs) => hs.communityName === selectedBulkCommunity) || [];
     const homesitesNeedingUpdate = homesitesToUpdate.filter(
          (hs) =>
               hs.conciergeSource !== "SF Opportunity" &&
               !(hs.conciergeName === selectedBulkConcierge?.name && hs.conciergeEmail === selectedBulkConcierge?.email) &&
               !(hs.conciergeName && hs.conciergeEmail)
     );

     const message = (
          <>
               Are you sure you want to assign <strong>{selectedBulkConcierge?.name}</strong> to <strong>{selectedBulkCommunity}</strong>?
               {homesitesNeedingUpdate.length > 0 && (
                    <span> This will assign {homesitesNeedingUpdate.length} homesite{homesitesNeedingUpdate.length === 1 ? "" : "s"}.</span>
               )}
          </>
     );

     return (
          <ConfirmDialog
               open={open}
               title="Assign Concierge to Community"
               message={message}
               isProcessing={isBulkAssigning}
               onConfirm={onConfirm}
               onCancel={onCancel}
          />
     );
};
